import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
import { NgbTimeConverter } from '../../common/service/ngbTimeConverter.utils';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'measure',
    templateUrl: 'measure.component.html'
})

export class MeasureComponent implements OnInit {
    public measureReg: string = '';
    public searchButton: boolean = false;
    public mainPage: boolean = true;
    public measurePage: boolean = false;
    public measureList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public isEdit: boolean = false;
    public datePicker: boolean = false;
    public trgType: any = '';
    public measureData: any = {
        name: null, measureCode: null, targetType: null, description: null, aggregator: null, 
        uomId: null, formulaExpression: null, staticValue: null, formatString: null, 
        dataVersion: null, dataVersionTime: null, startDataVersion: null, startDataVersionTime: null 
    };
    public indicators: any = [];
    public measureTargets: any = [];
    public trgMeasures: any = [];
    public staticMts: any = [];
    public dynamicMts: any = [];
    public coreMts: any = [];
    public corTrgList: any = [];
    public target: boolean = false;
    public measureTargetData: any = {
        id: null, measureId: null, name: '',
        corTargetId: null, deleted: 0, corTargetData: null
    };
    public uomList: any = [];

    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public endingPage: number = 0;
    public currentPage: number = 1;
    public selectedMeasureId: number;
    public totalMeasures: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;
    public lastRegex: string = '';
    public sPage: number = 0;

    constructor(public measureService: MDMService, public toastr: ToasterComponent, public vcr: ViewContainerRef,
        public ngbDateConv: NgbDateConverter, public ngbTimeConv: NgbTimeConverter) {
        this.toastr.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.measureService.isBIAdmin) {
            this.loadMeasure();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedMeasureId == null) {
            this.selectedMeasureId = event.target.id;
        } else {
            this.selectedMeasureId = null;
        }
    }

    public closeDropDown(){
        this.selectedMeasureId = null;
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.measureReg != '') {
            this.searchPMeasure();
        } else {
            this.loadMeasure();
        }
        this.setEndingPage(this.totalMeasures);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalMeasures / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadMeasure();
    }

    public loadMeasure() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.measureService.getDataByPage(BiUrls.MEASURE,
                self.pageNo, self.pageSize).then((res) => {
                    self.measureList = [];
                    self.totalMeasures = 0;
                    self.totalPages = 0;
                    if (res != undefined) {
                        self.measureList = res.data != undefined &&
                            res.data.pageElements != undefined ? res.data.pageElements :
                            self.toastr.showError('No results found');
                        self.totalMeasures = res.data != undefined &&
                            res.data.total != undefined ? res.data.total : 0;
                    }
                    // self.loadUom();
                    self.setEndingPage(self.totalMeasures);
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    public loadTargets() {
        return new Promise((resolve) => {
            let self = this;
            this.measureService.onStartUp(BiUrls.TARGET).then((res) => {
                self.corTrgList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    }

    // ByLalu
    public searchPMeasure() {
        return new Promise((resolve) => {
            let self = this;
            self.mainPage = true;
            self.loader = true;
            self.measureList = [];
            if (self.measureReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.measureReg;
            let resu = self.measureService.search(BiUrls.MEASURE, BiUrls.SEARCH_P_MEASURE,
                self.measureReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPMeasure(res);
                    self.loader = false;
                });
            resolve('completed');
        });

    }

    // ByLalu
    public loadSearchedPMeasure(res) {
        let self = this;
        self.measureList = (res != undefined) ? res.data.pageElements : [];
        self.totalMeasures = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalMeasures);
    }

    // public loadUom() {
    //     return new Promise((resolve) => {
    //         let self = this;
    //         this.measureService.onStartUp(BiUrls.UOM).then((res) => {
    //             self.uomList = res != undefined && res.data != undefined ? res.data : [];
    //         });
    //         resolve('completed');
    //     });
    // }

    public editMeasure(measure) {
        let self = this;
        self.isEdit = true;
        self.mainPage = false;
        self.measurePage = true;
        self.measureData = measure;

        // self.loader = true;
    }

    // public loadTrgMeasures(mearureId) {
    //     let self = this;
    //     let url = BiUrls.MEASURE + BiUrls.MEASURES_BY_CUBEMEASURES;
    //     self.measureService.getDataById(url, mearureId).then((res) => {
    //         if (res == undefined || (res.error != undefined && res.status != true)) {
    //             self.toastr.showError('Unable to fetch measures for target');
    //         } else {
    //             let list = res.data.sort((obj1, obj2) => {
    //                 let str1 = obj1['measureDisplayName'].toLowerCase();
    //                 let str2 = obj2['measureDisplayName'].toLowerCase();
    //                 if (str1 < str2) {
    //                     return -1;
    //                 } else if (str1 > str2) {
    //                     return 1;
    //                 } else {
    //                     return 0;
    //                 }
    //             });
    //             self.trgMeasures = list;
    //         }
    //     });
    // }

    public hasTarget(event) {
        if (event.target.checked == true) {
            this.target = true;
        } else if (event.target.checked == false) {
            this.target = false;
        }
    }

    // public save(measureData) {
    //     console.log("------------")
    //     console.log(measureData);
    //     this.measureData = measureData;
    //     let self = this;
    // //    else {
    //         self.saveButton = true;
    //         if (self.isEdit) {
    //             console.log('ON EDIT');
    //             self.measureService.update(BiUrls.MEASURE, self.measureData).then(res => {
    //                 let result = res;
    //                 self.loadAfterSaveOrEdit(result, 'edit');
    //             });
    //         } else {
    //             console.log('ON SAVE');
    //             self.measureService.save(BiUrls.MEASURE, self.measureData).then(res => {
    //                 let result = res;
    //                 self.loadAfterSaveOrEdit(result, 'new');
    //             });
    //         }
    //     // }
    // }

    public loadAfterSaveOrEdit(result) {
        let self = this;
        self.toastr.setViewRef(self.vcr);
        self.totalPages = Math.floor(self.totalMeasures / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        let text = result.type == 'new' ? 'Measure saved successfully' : 'Changes saved successfully';
        if (self.measureReg != '') {
            self.searchPMeasure().then((res) => {
                self.setPageFieldSAfterLoading();
                if (result.error == undefined && result.success == true) {
                    console.log(text);
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError(result.statusText);
                }

            });
        } else {
            self.loadMeasure().then(res => {
                self.setPageFieldSAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                } else {
                    self.toastr.showError(result.statusText);
                }

            }, (err) => {
                console.error(err);
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldSAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.measurePage = false;
        self.isEdit = false;
        self.selectedMeasureId = null;
        self.indicators = [];
        self.target = false;
    }

    public onBack() {
        this.mainPage = true;
        this.measurePage = false;
        this.measureData = {};
        this.target = false;
        this.indicators = [];
        this.isEdit = false;
        this.selectedMeasureId = null;
    }

    public addNewMeasure() {
        this.mainPage = false;
        this.measurePage = true;
        this.measureData = {
            id: null, name: '', description: '', targetType: 'max',
            aggregator: 'sum', measureDisplayName: '', deleted: 0
        }
    }

    public removeMeasure(measure) {
        let r = confirm('Are you sure you want to remove the measure ' + measure.name + ' ?');
        if (r == true) {
            this.delete(measure);
        }
    }

    public delete(measure) {
        let self = this;
        self.loader = true;
        self.measureService.delete(BiUrls.MEASURE, measure.id).then(response => {
            self.pageNo = self.measureList.length == 1 ?
                self.totalMeasures == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadMeasure();
            if (response.success) {
                self.toastr.showSuccess(measure.name + ' removed successfully');
            } else {
                self.toastr.showError('Unable to remove measure');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/measure.component.ts